import { render } from "./CheckboxControl.vue?vue&type=template&id=0a2c80b7&scoped=true"
import script from "./CheckboxControl.vue?vue&type=script&lang=js"
export * from "./CheckboxControl.vue?vue&type=script&lang=js"

import "./CheckboxControl.vue?vue&type=style&index=0&id=0a2c80b7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a2c80b7"]])

export default __exports__